import type { RepeaterReservation } from "@/lib/gql/__generated__/graphql";

import { TableBody, TableCell, TableRow } from "@/components/ui/table/table";

type Props = {
	reservation: RepeaterReservation;
	onClickReservation: () => void; // 予約詳細への遷移
};

export const TableTBody = (props: Props) => {
	const { reservation, onClickReservation } = props;

	return (
		<TableBody className="text-center">
			<TableRow
				className="cursor-pointer text-center transition-colors hover:bg-zinc-50"
				onClick={onClickReservation}
			>
				<TableCell className="text-center">{reservation.guestName}</TableCell>
				<TableCell className="text-center">{reservation.hotelName}</TableCell>
				<TableCell className="text-center">{reservation.guestEmail}</TableCell>
				<TableCell className="w-48 max-w-48 whitespace-pre-wrap break-words p-2 text-left">
					{reservation.memoByHost}
				</TableCell>
				<TableCell className="text-center">{reservation.reservationID}</TableCell>
				<TableCell className="text-center">
					{reservation.checkInDt}
					<br />
					{reservation.checkOutDt}
				</TableCell>
			</TableRow>
		</TableBody>
	);
};
